function megamenu() {
  const menu = document.querySelector("#desktopHeader");
  const firstLevelItems = menu?.querySelectorAll(".navlink--toplevel");
  const secondLevelDrawers = menu?.querySelectorAll(".menu__item--drawer");
  const overlays = menu?.querySelectorAll(".overlay");
  if (menu === null) return;

  firstLevelItems.forEach((firstLevelItem) => {
    let closeTimeout;
    const noMenu = firstLevelItem.matches('a.navlink--toplevel');

    firstLevelItem.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
      firstLevelItems.forEach((item) => {
        item.closest(".menu__item")?.setAttribute("aria-expanded", "false");
        menu
          ?.querySelectorAll('.menu__item[aria-expanded="true"]')
          .forEach((subitem) => {
            subitem.setAttribute("aria-expanded", "false");
          });
      });

      firstLevelItem.closest(".menu__item")?.setAttribute("aria-expanded", "true");
      // console.log(firstLevelItem);
      if (noMenu == false) {
        // document.body.classList.add("no-scroll");
        document.body.classList.remove("no-scroll"); // temp removal of all no-scroll to allow scrolling with megamenu open
      }
    });

    if (noMenu) {
      firstLevelItem.addEventListener("mouseleave", () => {
        closeTimeout = setTimeout(() => {
          firstLevelItem.closest(".menu__item")?.setAttribute("aria-expanded", "false");
          document.body.classList.remove("no-scroll");
        }, 200);
      });
    }
  });

  overlays.forEach((overlay) => {
    overlay.addEventListener("click", () => {
      overlay.closest(".menu__item").setAttribute("aria-expanded", "false");
      document.body.classList.remove("no-scroll");
    });
  });

  secondLevelDrawers.forEach((drawer) => {
    const closeIcon = drawer.querySelector(".menu__item--drawer-close");
    const secondLevelItems = drawer.querySelectorAll('.navlink--secondlevel:not(.title-second-drawer)');
    const thirdLevelDrawers = drawer.querySelectorAll(
      ".menu__item--second-drawer"
    );

    closeIcon.addEventListener("click", () => {
      drawer.closest(".menu__item").setAttribute("aria-expanded", "false");
      document.body.classList.remove("no-scroll");
    });

    secondLevelItems.forEach((secondLevelItem) => {
      secondLevelItem
        .closest(".menu__item")?.addEventListener("mouseover", () => {
          const menuItem = secondLevelItem.closest(".menu__item");
          const isExpanded = menuItem.getAttribute("aria-expanded") === "true";
          menuItem.setAttribute("aria-expanded", !isExpanded);

          if (!isExpanded) {
            secondLevelItems.forEach((item) => {
              const itemMenu = item.closest(".menu__item");
              if (itemMenu !== menuItem) {
                itemMenu?.setAttribute("aria-expanded", "false");
              }
            });

            closeIcon.classList.add("hidden");
          }
        });

      secondLevelItem
        .closest(".menu__item")?.addEventListener("mouseout", () => {
          const menuItem = secondLevelItem.closest(".menu__item");
          const isExpanded = menuItem?.getAttribute("aria-expanded") === "true";
          menuItem.setAttribute("aria-expanded", !isExpanded);

          closeIcon.classList.remove("hidden");
        });
    });

    thirdLevelDrawers.forEach((thirdLevelDrawer) => {
      const secondCloseIcon = thirdLevelDrawer.querySelector(
        ".menu__item--drawer-close"
      );

      secondCloseIcon.addEventListener("click", () => {
        thirdLevelDrawer
          .closest(".menu__item")?.setAttribute("aria-expanded", "false");
        drawer.closest(".menu__item")?.setAttribute("aria-expanded", "false");
        closeIcon.classList.remove("hidden");
        document.body.classList.remove("no-scroll");
      });
    });
  });
}

function getFocusableElements(container) {
  return Array.prototype.slice
    .call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    )
    .filter((el) => {
      const visible = el.offsetWidth || el.offsetHeight || el.getClientRects().length;
      return visible && !el.closest("[inert]");
    });
}

function mobileMegamenu() {
  const hamburguerButton = document.querySelector(
    ".header__mobile__hamburger"
  );
  const menu = document.querySelector("#mobileHeader");
  const drawer = menu?.querySelector(".menu__item--drawer-mobile");
  if (!hamburguerButton || !drawer) return;

  const closeButtons = drawer.querySelectorAll(".menu__item--drawer-close");
  const backButtons = drawer.querySelectorAll(".menu__item--drawer-back");
  const menuItems = drawer.querySelectorAll(".navlink--secondlevel.navlink--dropdown");
  const secondDrawers = drawer.querySelectorAll(".menu__item--second-drawer");
  const dropdownTriggers = drawer.querySelectorAll('.navlink--dropdown[role="button"]');

  let drawerKeydownHandler = null;

  function setExpanded(trigger, expanded) {
    trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
    trigger.closest(".menu__item")?.setAttribute(
      "aria-expanded",
      expanded ? "true" : "false"
    );
  }

  // Second/third-level drawers are position:fixed panels that cover the
  // whole screen when open, but everything "underneath" them (sibling menu
  // items, the drawer's own trigger row, other wrapper sections) stays in
  // normal document flow - so it stays keyboard-focusable even though it's
  // completely covered. This walks from the deepest currently-open panel up
  // to the drawer root, marking every sibling along the way as inert, so
  // only the panel that's actually visible can be tabbed into.
  function findActivePanel() {
    const openPanels = drawer.querySelectorAll(
      '.menu__item[aria-expanded="true"] > .menu__item--second-drawer, .menu__item[aria-expanded="true"] > .menu__item--third-drawer'
    );
    let deepest = null;
    openPanels.forEach((panel) => {
      if (!deepest || panel.contains(deepest)) deepest = panel;
    });
    return deepest;
  }

  function syncNestedInert() {
    drawer.querySelectorAll("[data-nav-inert]").forEach((el) => {
      el.removeAttribute("inert");
      el.removeAttribute("data-nav-inert");
    });

    const active = findActivePanel();
    if (!active) return;

    let current = active;
    while (current && current !== drawer) {
      const parent = current.parentElement;
      if (!parent) break;

      Array.prototype.forEach.call(parent.children, (child) => {
        if (child !== current) {
          child.setAttribute("inert", "");
          child.setAttribute("data-nav-inert", "");
        }
      });

      current = parent;
    }
  }

  function focusActivePanel() {
    const activePanel = findActivePanel();
    if (!activePanel) return;
    const focusable = getFocusableElements(activePanel);
    if (focusable.length) focusable[0].focus();
  }

  function closeDrawer() {
    // Move focus out before marking the drawer inert - an inert subtree
    // can't contain the active element.
    if (drawer.contains(document.activeElement)) {
      hamburguerButton.focus();
    }

    drawer.classList.remove("show");
    drawer.setAttribute("inert", "");
    hamburguerButton.setAttribute("aria-expanded", "false");
    document.body.classList.remove("no-scroll");

    dropdownTriggers.forEach((trigger) => {
      setExpanded(trigger, false);
    });
    syncNestedInert();

    if (drawerKeydownHandler) {
      document.removeEventListener("keydown", drawerKeydownHandler);
      drawerKeydownHandler = null;
    }
  }

  function openDrawer() {
    drawer.removeAttribute("inert");
    drawer.classList.add("show");
    hamburguerButton.setAttribute("aria-expanded", "true");
    document.body.classList.add("no-scroll");

    drawerKeydownHandler = function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== "Tab") return;

      const focusable = getFocusableElements(drawer);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", drawerKeydownHandler);

    const focusable = getFocusableElements(drawer);
    if (focusable.length) focusable[0].focus();
  }

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      closeDrawer();
    });
  });

  hamburguerButton.addEventListener("click", () => {
    if (drawer.classList.contains("show")) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  dropdownTriggers.forEach((trigger) => {
    trigger.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        trigger.click();
      }
    });
  });

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("click", (event) => {
      // console.log(menuItem);

      menuItems.forEach((menuItem) => {
        setExpanded(menuItem, false);
      });

      setExpanded(menuItem, true);
      syncNestedInert();
      if (event.detail === 0) focusActivePanel();
    });

    const imageElement = menuItem
      .closest(".menu__item")
      ?.querySelector(".menu__item--collection-image");
    if (imageElement != null) {
      imageElement.addEventListener("click", () => {
        menuItems.forEach((menuItem) => {
          setExpanded(menuItem, false);
        });

        setExpanded(menuItem, true);
        syncNestedInert();
      });
    }
  });

  backButtons.forEach((backButton) => {
    backButton.addEventListener("click", () => {
      const parentPanel = backButton.closest(".menu__item--second-drawer");
      const parentTrigger = parentPanel?.parentElement?.querySelector(
        ":scope > .navlink--dropdown"
      );
      menuItems.forEach((menuItem) => {
        setExpanded(menuItem, false);
      });
      syncNestedInert();
      parentTrigger?.focus();
    });
  });

  secondDrawers.forEach((secondDrawer) => {
    const secondLevelItems = secondDrawer.querySelectorAll(
      ".navlink--thirdlevel.navlink--dropdown"
    );
    const backButtons = secondDrawer.querySelectorAll(
      ".menu__item--drawer-back--last"
    );

    backButtons.forEach((backButton) => {
      backButton.addEventListener("click", () => {
        const parentPanel = backButton.closest(".menu__item--third-drawer");
        const parentTrigger = parentPanel?.parentElement?.querySelector(
          ":scope > .navlink--dropdown"
        );
        secondLevelItems.forEach((secondLevelItem) => {
          setExpanded(secondLevelItem, false);
        });
        syncNestedInert();
        parentTrigger?.focus();
      });
    });

    secondLevelItems.forEach((secondLevelItem) => {
      secondLevelItem.addEventListener("click", (event) => {
        secondLevelItems.forEach((secondLevelItem) => {
          setExpanded(secondLevelItem, false);
        });

        setExpanded(secondLevelItem, true);
        syncNestedInert();
        if (event.detail === 0) focusActivePanel();
      });
    });
  });
}

megamenu();
mobileMegamenu();
